import { call, put, takeEvery } from 'redux-saga/effects';
import { _BROTHER_PLUS_API_ENDPOINTS } from '../../../constants/AppConstants';
import { _CALLGETAPI } from '../../../api/apiHandler';
import { fetchBrotherPlusPrintersRequest, fetchBrotherPlusPrintersSuccess, fetchBrotherPlusPrintersFailure } from './brotherPlusPrintersSlice';
import i18next from 'i18next';

function _GETBROTHERPLUSPRINTERS() {
    const endpoint = _BROTHER_PLUS_API_ENDPOINTS.BROTHER_PLUS_PRINTERS;
    return _CALLGETAPI(endpoint)
    .then(response => {
        return response;
    })
    .catch((error) => {
        throw error;
    });
}

function* fetchBrotherPlusPrintersSaga(action) {
    try {

        const response = yield call(_GETBROTHERPLUSPRINTERS);

        if (response!==null && response.length > 0) {
            yield put(fetchBrotherPlusPrintersSuccess(response));
        } else {
            yield put(fetchBrotherPlusPrintersFailure({ message: i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR") }));
        }
    } catch (error) {
        yield put(fetchBrotherPlusPrintersFailure({ message: error.message }));
    }
}

export default function* watchFetchBrotherPlusPrinters() {
    yield takeEvery(fetchBrotherPlusPrintersRequest.type, fetchBrotherPlusPrintersSaga);
}